class ContentTabs extends HTMLElement {
  constructor() {
    super();

    this.contentTabsButtons = this.querySelectorAll(".shop-by-shape__button");
    this.contentTabsContent = this.querySelectorAll(".shop-by-shape__content");

    this.contentTabsButtons.forEach((contentTabButton, index) => {
      contentTabButton.addEventListener("click", () => {
        this.contentTabsButtons.forEach((tabButton) => {
          tabButton.classList.remove("button--active");
        });
        contentTabButton.classList.add("button--active");
        let tabID = this.contentTabsButtons[index].id;
        this.contentTabsContent.forEach((contentTabContent) => {
          contentTabContent.classList.remove("tab--active");
        });
        document.getElementById(tabID + "-content").classList.add("tab--active");
      });
    });
  }
}

customElements.define("content-tabs", ContentTabs);
